<template>
  <div class="expande-horizontal pa-3 pl-1 pb-0 pt-0 pr-0 fonte">
    <v-flex xs12>
      <v-text-field
        v-model="filter.search"
        dense
        filled
        append-icon="mdi-magnify"
        label="Faça uma busca..."
        placeholder="ex: ABC1D23"
        hide-details
        :color="$theme.primary"
        @input="$forceUpdate()"
      ></v-text-field>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: ["filter"]
};
</script>
